export default __webpack_public_path__ + "static/media/lastframe-sm-1x.44afb6a1.jpg";